import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { Constants } from '../helpers/constants';


export const enappgyDataServiceApi = createApi({
  reducerPath: 'enappgyDataServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://data.dev.enappgy.io/Data',
  }),

  endpoints: (builder) => ({
    //Queries
    getEnergyConsumptionByFilter: builder.query({
      query: ({filter, buildingId}) => {
        // Converting the params object into a query string
        const queryString = Object.keys(filter)
          .map((key) => `${key}=${filter[key]}`)
          .join('&');

        return `${Constants.TENANT_ID}/c5752d42-72b6-496a-a352-b698d4df4c2e/NormalMeasurementsByPeriod?${queryString}`},
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetEnergyConsumptionByFilterQuery } = enappgyDataServiceApi
